import { usages } from "@/config/useages";
import sphCylInRange from "./sphCylInRange";
import { getRandom } from "../commonService";
import { cloneDeepWith } from "lodash";

// 多少人选择的假数据
function getChoosese(lens: number) {
    // 如果套餐
    if (lens < 2) {
        return [];
    } else if (lens === 2) {
        const min = getRandom(10, 15);
        const max = (100 - min).toFixed(2);
        return [min, max];
    } else if (lens === 3) {
        const min = getRandom(10, 15);
        const max = getRandom(70, 75);
        const mid = (100 - min - max).toFixed(2);
        return [min, mid, max];
    }
}

//筛选显示的usage
export const filterUsage = (lensInfo: any) => {
    let data = cloneDeepWith(usages);
    if (!lensInfo) {
        return data;
    }
    const {
        rimless,
        isFrameHeightLessThan30,
        rx,
        cate,
        isSelectType,
        lensType,
    } = lensInfo;
    // 默认看远
    const { notShowBifocalWithLine, notShowProgressiveNoLine } = sphCylInRange({
        ...rx,
        glassType: cate,
    });
    // 镜架高度小于30 ，不能做双光镜片
    if (isFrameHeightLessThan30) {
        data = data.filter((item) => item.name !== "multifocal");
    }
    // 联合光度判断
    if (notShowBifocalWithLine && notShowProgressiveNoLine) {
        data = data.filter((item) => item.name !== "multifocal");
    } else {
        if (notShowBifocalWithLine || rimless)
            data = data.map((item) => {
                item.children = item.children.filter(
                    (ch) => ch.name !== "bifocal",
                );
                return item;
            });
        if (notShowProgressiveNoLine)
            data = data.map((item) => {
                item.children = item.children.filter(
                    (ch) => !["standardPL", "advancedPL"].includes(ch.name),
                );
                return item;
            });
    }

    if (location.search.match(/isBlue\=1/) != null) {
        data = data.filter((item) => item.name !== "multifocal");
    }

    if (isSelectType) {
        if (lensType === 4 || lensType === 10) {
            data = data.filter((item) => item.name !== "multifocal");
        }

        if (lensType === 10) {
            data = data.map((item) => {
                item.children = item.children.filter(
                    (ch) => ch.name !== "intermediate" && ch.name !== "near",
                );
                return item;
            });
        }
    }

    const choosese = getChoosese(data.length);
    data = data.map((item, index) => ({
        ...item,
        choosed: choosese?.[index],
    }));

    if (RegExp(/isBlue\=1/).exec(location.search) != null) {
        data = data.filter((item) => item.name !== "multifocal");
    }

    return data;
};

//判断双光是否默认选中
export const isAdd = (lensInfo: any) => {
    if (!lensInfo) {
        return false;
    }
    const { rx } = lensInfo;
    const add = parseFloat(rx.add);
    const birth = parseFloat(rx.birth_year);
    const nowYear = new Date().getFullYear();

    // 没填判断小于40岁
    const oldThan40 = !birth ? false : nowYear - birth >= 40;

    return oldThan40 && add;
};

// 输出sph和cyl
function assign(sph: number, cyl: number) {
    return { sph, cyl };
}
// 解析数字
function parse(str: string | number) {
    if (typeof str === "string") {
        return parseFloat(str);
    } else if (typeof str === "number") {
        return str;
    } else {
        throw new Error("need a string or number!");
    }
}

// 看中ADD对照，联合光度和是否偏心需要转化后再判断
export function addToSphMap(
    sph: string | number,
    add: string | number,
    usage?: string,
) {
    sph = parse(sph);
    add = parse(add);
    if (usage === "distance") {
        return sph;
    } else if (usage === "intermediate") {
        switch (true) {
            case add === 0:
                return sph;
            case add <= 1:
                return sph + add - 0.25;
            case add <= 1.75:
                return sph + add - 0.5;
            case add <= 2.5:
                return sph + add - 0.75;
            case add <= 3.25:
                return sph + add - 1;
            case add <= 4:
                return sph + add - 1.25;
            case add <= 4.5:
                return sph + add - 1.5;
            default:
                throw new Error("wrong add number!");
        }
    } else if (usage === "near") {
        return sph + add;
    } else {
        return sph;
    }
}
